import { Row } from "react-bootstrap";
import ChartItem from "./ChartItem"; // ✅ DEFAULT IMPORT

export default function ChartSection({
  izinKeys,
  chartData,
  colors,
}) {
  return (
    <Row className="g-3">
      {izinKeys.map((key) => (
        <ChartItem
          key={key}
          izinKey={key}
          data={chartData[key] || []}
          color={colors[key].iconBg}
        />
      ))}
    </Row>
  );
}
